"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
var Container = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  height: 100%;\n  text-align: center;\n  min-height: ", ";\n  max-width: ", ";\n  margin: ", ";\n"])), function (props) {
  return props.minHeight;
}, function (props) {
  var _props$theme;
  return (props === null || props === void 0 || (_props$theme = props.theme) === null || _props$theme === void 0 || (_props$theme = _props$theme.header) === null || _props$theme === void 0 ? void 0 : _props$theme.width) || '1200px';
}, function (_ref) {
  var margin = _ref.margin;
  return margin === 'small' ? '1em' : margin === 'medium' ? '2em' : margin === 'large' ? '4em' : margin;
});
Container.propTypes = {
  margin: _propTypes["default"].string,
  minHeight: _propTypes["default"].string
}, Container.defaultProps = {
  margin: '0 auto',
  minHeight: 'initial'
};
var _default = exports["default"] = Container;